import { BaseQueryApi } from "@reduxjs/toolkit/query";
import { TransactionIdScopeType } from "../../../enums/transactionIdScopeType";
import { v4 as uuidv4 } from "uuid";
import { RootState } from "../../stores/store";

export const populateTransactionId = (api: BaseQueryApi, scopeType: TransactionIdScopeType | undefined) => {
  const pageEndpointsToUpdateTransactionId = ["getProperty", "getLoans", "getConsents"];

  api.dispatch({
    type: "transactionIdSlice/setCurrentScopeType",
    payload: scopeType ?? TransactionIdScopeType.SystemScope,
  });
  if (scopeType && scopeType === TransactionIdScopeType.PageScope) {
    if (pageEndpointsToUpdateTransactionId.some((s) => s === api.endpoint)) {
      api.dispatch({
        type: "transactionIdSlice/setPageScopeTransactionId",
        payload: uuidv4(),
      });
    }
  } else {
    api.dispatch({
      type: "transactionIdSlice/setSystemScopeTransactionId",
      payload: uuidv4(),
    });
  }
};

export const getTransactionId = (rootState: RootState) => {
  const currentScopeType = rootState.transactionIdSlice.currentScopeType;
  let transactionId = "";
  if (currentScopeType === TransactionIdScopeType.PageScope) {
    const pageScopeTransactionId = rootState.transactionIdSlice.pageScopeTransactionId;
    if (!pageScopeTransactionId) {
      throw Error("Check pageEndpointsToUpdateTransactionId collection, probably a new page wasn't added.");
    } else {
      transactionId = pageScopeTransactionId;
    }
  } else {
    transactionId = rootState.transactionIdSlice.systemScopeTransactionId;
  }
  return transactionId;
};
